import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { Audit } from './audit';
import { Till } from './till';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceType } from '../types';
import { SessionType } from '../types';
import { TillType } from '../types';
import { AuditType } from '../types';

export type TillChangeKind = 'CASH' | 'CARD';

const _schema = {
    name: 'TILLCHANGE',
    fields: [
        { name: 'place', type: 'objid' },
        { name: 'session', type: 'objid' },
        { name: 'till', type: 'objid' },
        { name: 'audit', type: 'objid' },
        { name: 'type', type: 'string', default: "'CASH'" },
        { name: 'concept', type: 'string' },
        { name: 'amount', type: 'number', default: '0' },
    ],
    relate: [
        { direction: '>', target: 'PLACE', by: 'place', name: 'place', reason: 'place', child: false, class: PlaceType },
        { direction: '>', target: 'SESSION', by: 'session', name: 'session', reason: 'session', child: false, class: SessionType },
        { direction: '>', target: 'TILL', by: 'till', name: 'till', reason: 'till', child: false, class: TillType },
        { direction: '>', target: 'AUDIT', by: 'audit', name: 'audit', reason: 'audit', child: false, class: AuditType },
    ],
} as const;

const _TillChangeClass = CreateObject(_schema);
if (!_TillChangeClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class TillChange extends _TillChangeClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null) {
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): TillChange {
        return this._Copy(store) as TillChange;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf){
            return;
        }

        if (relation === 'till' && related instanceof Till){
            if (related === this.till){
                related.AddTillchange(this);
            }
            else {
                related.DelTillchange(this);
            }
            return;
        }

        if (relation === 'audit' && related instanceof Audit){
            if (related === this.audit){
                related.AddTillchange(this);
            }
            else {
                related.DelTillchange(this);
            }
        }
    }
}
